import React from "react";
import NavbarPharmacy from "../NavbarPharmacy";
import ReactSelect from "react-select";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { useActions } from "../use-actions";
import moment from "moment";
import { isEmpty } from "lodash";
import { Card, CardBody } from "reactstrap";
import SectionHeader from "@dhn/components/molecules/section-header";

export default function OffersArs({ profile, user, pharmacy }) {
  const [{ state }, { onSelectArs, reportOfferArs, onChange }] = useActions({
    loggedUserData: user,
  });
  const validateOfferExist = isEmpty(state.offerSelected);
  return (
    <div className="animated fadeIn">
      <NavbarPharmacy profile={profile} user={user} pharmacy={pharmacy} />

      {/*************************BODY********************/}
      <Card className="m-4">
        <CardBody>
          <SectionHeader icon="fa-tags" title="Ofertas Por ARS" compact />
          <div className="py-5">
            <Row form>
              <Col md={4}>
                <Label className="">{"Aseguradora:"}</Label>
                <div>
                  <ReactSelect
                    classNamePrefix="dhn-select"
                    placeholder="Seleccione ARS"
                    options={state.arsList || []}
                    // value={Object.keys(state?.ars).length ? state?.ars : null}
                    getOptionLabel={(item) => item.arsName}
                    getOptionValue={(item) => item}
                    onChange={(item) => {
                      onSelectArs(item, 5);
                    }}
                  />
                </div>
              </Col>
              <Col md={4}>
                <Label className="">{"Ofertas:"}</Label>
                <div>
                  <ReactSelect
                    classNamePrefix="dhn-select"
                    isDisabled={!state?.dataOffers.length}
                    placeholder="Seleccionar Oferta"
                    options={state?.dataOffers || []}
                    getOptionLabel={(item) => item.nameOffer}
                    value={!validateOfferExist ? state?.offerSelected : null}
                    getOptionValue={(item) => item}
                    onChange={(item) => {
                      onChange("offerSelected", item);
                    }}
                  />
                </div>
              </Col>
              <Col md={4}>
                <Label className="">{"Periodo:"}</Label>
                <div>
                  <Input
                    disabled
                    value={
                      validateOfferExist
                        ? ""
                        : `${moment(state.offerSelected.fromDate).format("DD/MM/YYYY")} - ${moment(state.offerSelected.toDate).format("DD/MM/YYYY")}`
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
          <Row className="border-top py-4">
            <Col md={5}>
              <Button
                onClick={() => reportOfferArs()}
                disabled={validateOfferExist}
                color="success"
                className="btn-color-success"
              >
                <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                {" Generar Reporte PDF"}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
}
